import { useEffect, useState } from "react";

import logo_presentation from '../img/presentation.jpg';
import logo_electrique from '../img/electrique.jpg';
import logo_came from '../img/came.png';
import logo_domovea from '../img/domovea.jpg';
import logo_house from '../img/house_panel.png';
import logo_urmet from '../img/urmet.png';
import logo_qualifelec from '../img/qualifelec.jpg';
import logo_qualifelec_irve from '../img/qualifelec_irve.jpg';

const certificationsImageMap = {
    logo_electrique,
    logo_house,
    logo_domovea,
    logo_urmet,
    logo_came,
    logo_qualifelec,
    logo_qualifelec_irve
};

const Presentation = () => {
    const [certifications, setCertifications] = useState([]);

    useEffect(() => {
        fetch("/certifications")
            .then(res => res.json())
            .then(data => setCertifications(data))
            .catch(err => console.error(err));
    }, []);

    return (
        <section id="presentation" className="bg-light-backgroundAlt dark:bg-dark-backgroundAlt p-6 h-full">
            <div className="h-2/3">
                <h2 className="text-3xl text-center text-light-text dark:text-dark-text pt-2 pb-5">
                    Présentation
                </h2>

                <div className="flex max-sm:flex-col">
                    <div className="max-sm:w-full w-1/2 flex flex-col justify-center items-center">
                        <img
                            src={logo_presentation}
                            alt="T.ELEC, entreprise d'électricité à Nancy"
                        />
                    </div>

                    <div className="max-sm:w-full w-1/2 flex justify-center items-center pl-10">
                        <div>
                            <h3 className="text-light-text dark:text-dark-text text-2xl pt-6 pb-6">
                                Qui sommes-nous ?
                            </h3>
                            <p className="text-light-text dark:text-dark-text pt-2">
                                Depuis 2007, T.ELEC fondée par Thierry Engelhardt accompagne ses clients dans leurs travaux d’électricité à Nancy, en Lorraine et alentours.
                            </p>

                            <h3 className="text-light-text dark:text-dark-text text-2xl pt-6 pb-6">
                                Nos prestations
                            </h3>
                            <p className="text-light-text dark:text-dark-text pt-2">
                                Dépannage, installation, rénovation, motorisation de portails, bornes de recharge, domotique, interphonie et travaux électriques pour particuliers et professionnels.
                            </p>

                            <h3 className="text-light-text dark:text-dark-text text-2xl pt-6 pb-6">
                                Pourquoi nous choisir ?
                            </h3>
                            <p className="text-light-text dark:text-dark-text pt-2">
                                Une expertise technique, des conseils adaptés, des installations soignées et plusieurs certifications reconnues pour vous garantir un travail de qualité.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="h-1/3 max-sm:mt-5">
                <h2 className="text-3xl text-center text-light-text dark:text-dark-text pt-5 pb-5">
                    Nos certifications
                </h2>

                <div className="flex w-full">
                    <div className="flex flex-row max-sm:flex-wrap w-full justify-between pt-5 pb-5">
                        {certifications.map((certification) => (
                            <div
                                key={certification.title}
                                className="flex flex-col items-center justify-center max-sm:w-1/2 max-sm:mt-5"
                            >
                                <h3 className="font-bold text-light-text dark:text-dark-text pb-3 max-sm:text-xs">
                                    {certification.title}
                                </h3>
                                <img
                                    className="w-24 h-24"
                                    src={certificationsImageMap[certification.image]}
                                    alt={`Certification ${certification.title}`}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Presentation;